export const ASSIGNMENT_TYPES = {
  TRANSLATE: 1,
  PEER_REVIEW: 2,
  MODEL_ASSESSMENT: 3,
  PRONOUNS: 4,
  MODEL_SELECTION: 5,
  REFDOCS: 6,
  PEER_REVIEW_VERSE: 7,
  TRANSLATE_EDIT: 8,
  // TODO: Rest of types
};
